import * as React from 'react';
import styles from './index.less';
import { Modal, Space } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import FIcons from '@/components/FIcons';

interface FProcessingProps {
  open?: boolean;
  message: string;
}

function FProcessing({ open, message }: FProcessingProps) {
  return (<Modal
    open={open}
    title={null}
    footer={null}
    width={312}
    styles={{
      body: {
        backgroundColor: 'white',
        borderRadius: 6,
        backdropFilter: 'blur(5px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#2784FF',
        height: 200,
        fontSize: 16,
        lineHeight: '22px',
      },
    }}
    style={{ backgroundColor: 'transparent', borderRadius: 10, overflow: 'hidden' }}
    mask={true}
    centered={true}
    closable={false}
    afterClose={() => {
    }}
    focusTriggerAfterClose={false}
  >
    <Space size={10}>
      <FIcons.FLoading style={{ fontSize: 16 }} />
      <span>{message}</span>
    </Space>
  </Modal>);
}

export default FProcessing;
